import { getRole } from "helpers/permissions/roles"
import withNavigate from "hocs/withNavigate"
import createModule from "../createModule"
import { getSolutions, getSigmaSolutions } from "./selectors"
import view from "./view"

const SolutionsModule = createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [
    {
      resource: "solutions",
      as: null,
      url: ({ account }) => `/api/${account}/solutions`,
    },
    {
      resource: "sigmaSolutions",
      as: null,
      url: ({ account }) => `/api/${account}/solutions/sigma`,
    },
  ],
  mapStateToProps: (state, props) => ({
    solutions: getSolutions(state, props),
    sigmaSolutions: getSigmaSolutions(state, props),
    accountAlias: state.global.selected.account,
    role: getRole(state),
    isSuperuser: state.user.isSuperuser,
  }),
})

export default withNavigate(SolutionsModule)
